import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Supplier } from 'types/supplier';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface SupplierItemProps {
  option: Supplier;
  selected: Supplier | null;
  handleSelect(supplier: Supplier): void;
}

const SupplierItem: React.FC<SupplierItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.company_name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default SupplierItem;
